<template>
  <div class="overflow-hidden">
    <div
      class="alert-container text-white text-center"
      :class="
        alert && (alert.message == 'Error!' || alert.type == 'success')
          ? bgClass
          : 'alert-container-hide'
      "
    >
      <div class="position-relative p-4">
        <span>{{ alert ? alert.message : "" }}</span>
        <span @click="hideAlert" class="close-alert">X</span>
      </div>
    </div>
    <b-modal
      centered
      :title="alert ? alert.title : ''"
      header-bg-variant="danger"
      header-text-variant="white"
      v-model="showAlertMessage"
      no-close-on-backdrop
      :modal-class="multiline"
    >
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="cancel()">
          Ok
        </b-button>
      </template>
      {{ alert && alert.message ? alert.message : "" }}
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "DialogError",
  methods: {
    ...mapActions("layout", ["hideAlert"])
  },
  computed: {
    ...mapState("layout", {
      alert: state => state.alert
    }),
    bgClass() {
      if (this.alert) {
        switch (this.alert.type) {
          case "success":
            return "bg-success";
          case "error":
            return "bg-danger";
        }
      }
      return "";
    },
    showAlertMessage: {
      get() {
        return (
          this.alert &&
          this.alert.message != "Error!" &&
          this.alert.type == "error"
        );
      },
      set() {
        this.hideAlert();
      }
    },
    multiline() {
      if (this.alert && this.alert.multiline) return ["multiline"];
      return [];
    }
  }
};
</script>

<style>
.multiline {
  white-space: pre-line;
}
</style>

<style scoped>
.alert-container {
  z-index: 9999;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  animation: appear 0.5s;
  -moz-animation: appear 0.5s;
  -webkit-animation: appear 0.5s;
}
.alert-container-hide {
  display: none;
}

.close-alert:hover {
  cursor: pointer;
}
.close-alert {
  position: absolute;
  top: 3px;
  right: 10px;
}
</style>
<style>
@keyframes appear {
  from {
    opacity: 0%;
  }
  to {
    opacity: 100%;
  }
}
@-moz-keyframes appear {
  from {
    opacity: 0%;
  }
  to {
    opacity: 100%;
  }
}
@-webkit-keyframes appear {
  from {
    opacity: 0%;
  }
  to {
    opacity: 100%;
  }
}
</style>
